// @flow
import React from 'react';
import styles from './searchClient.scss';

import {
  getUniqueId,
  strUsables,
  formattedList
} from '../../../services/helpers';

type Props = {
  title: string,
  onChange: Function, // on input change
  onSelect: Function, // on option select
  searchOptions: Array<any>,
  displayAccessorArray: Array<string>,
  displaySeparator: string,
  selectedOpt: Object,
  placeholder?: string
};

type State = {
  searchOptions: Array<any>,
  showOptions: boolean,
  inputValue: string,
  selectAction: boolean
};

class SearchClient extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      searchOptions: this.props.searchOptions || [],
      showOptions: false,
      inputValue: this.getElementDisplayValue(this.props.selectedOpt) || '',
      selectAction: false
    };

    this.inputFieldId = `input-field-${getUniqueId(4)}`;
  }

  componentDidMount() {
    this.attachDocumentLevelEventHandler(); // hacky solution
  }

  componentWillReceiveProps(nextProps: Object) {
    if (nextProps.selectedOpt && this.props.selectedOpt) {
      if (
        this.getElementDisplayValue(nextProps.selectedOpt) !==
        this.getElementDisplayValue(this.props.selectedOpt)
      ) {
        // Selected option is changed.
        this.updateSearchOptionsVal(nextProps, true, true);
      } else if (
        this.getElementDisplayValue(nextProps.selectedOpt) ===
        this.getElementDisplayValue(this.props.selectedOpt)
      ) {
        // We are searching but selected option is same as previous prop. Update only the search option list
        this.updateSearchOptionsVal(nextProps, true, false);
      }
    }
  }

  onSelectHandler(rowObj: Object) {
    // eslint-disable-next-line no-console
    console.log('selected option= ', rowObj);
    this.setState(
      {
        selectAction: true
      },
      () => {
        if (this.props.onSelect) {
          this.props.onSelect(rowObj);
        }
      }
    );
  }

  onChangeHandler(e: Object) {
    // Changing input field - should be used for searching in list
    const onChangeVal = e.target.value;
    // eslint-disable-next-line no-console
    console.log('onChange val= ', onChangeVal);
    this.setState(
      {
        inputValue: onChangeVal,
        selectAction: false
      },
      () => {
        if (this.props.onChange) {
          this.props.onChange(onChangeVal);
        }
      }
    );
  }

  getElementDisplayValue(elem) {
    const { displayAccessorArray } = this.props;
    const toReturnList = [];
    if (displayAccessorArray.length) {
      displayAccessorArray.map(acc => {
        if (elem[acc]) {
          toReturnList.push(elem[acc]);
        }
        return acc; // for eslint
      });
    }
    const separatorStr = strUsables.emptySpace + this.props.displaySeparator;
    return formattedList(toReturnList, separatorStr);
  }

  updateSearchOptionsVal(
    nextProps: Object,
    updateSearchOptionlist: boolean,
    updateInputDisplayFromProps: boolean
  ) {
    if (updateSearchOptionlist && updateInputDisplayFromProps) {
      this.setState({
        searchOptions: nextProps.searchOptions,
        inputValue: this.getElementDisplayValue(nextProps.selectedOpt) || ''
      });
    } else if (updateSearchOptionlist && !updateInputDisplayFromProps) {
      if (this.state.selectAction) {
        // I have selected an option
        this.setState({
          searchOptions: nextProps.searchOptions,
          inputValue: this.getElementDisplayValue(nextProps.selectedOpt)
        });
      } else {
        this.setState({
          searchOptions: nextProps.searchOptions,
          inputValue: this.state.inputValue
        });
      }
    }
  }

  attachDocumentLevelEventHandler() {
    // flow-disable-next-line
    document.querySelector('body').addEventListener('mousedown', e => {
      const inputSearchElem = e.target.closest(`#${this.inputFieldId}`); // search input

      // eslint-disable-next-line
      if (inputSearchElem) {
        // show options-wrapper
        this.setState({
          showOptions: true
        });
      } else if (this.state.showOptions) {
        // hide options wrapper
        setTimeout(() => {
          this.setState({
            showOptions: false
          });
        }, 200);
      }
    });
  }

  inputFieldId: string;

  renderSearchOptions() {
    return (
      <div className={`${styles.searchOptionsWrapper}`}>
        {this.state.searchOptions.map((elem, i) => (
          <div
            key={i}
            className={`${styles.optionsRow}`}
            onClick={() => this.onSelectHandler(elem)}
          >
            {this.getElementDisplayValue(elem)}
          </div>
        ))}
      </div>
    );
  }

  render() {
    return (
      <div className="search-utility-wrapper l-row j-center a-center">
        <div className={`${styles.searchTitle} search-title`}>
          {this.props.title}
        </div>
        <div className={`${styles.searchBox}`}>
          <input
            id={this.inputFieldId}
            className={`${styles.searchBoxInput} search-box-input`}
            value={this.state.inputValue}
            onChange={e => this.onChangeHandler(e)}
            title={this.state.inputValue}
            placeholder={this.props.placeholder || ''}
          />

          {this.state.showOptions ? this.renderSearchOptions() : null}
        </div>
      </div>
    );
  }
}

SearchClient.defaultProps = {
  placeholder: 'Search'
};

export default SearchClient;
